export class InterviewStatusEnum {
    readonly id: number;
    readonly label: string;

    public isIn = (arr: { id: number }[]): boolean => {
        arr = arr != null ? arr : [];
        return arr.findIndex(t => t.id === this.id) >= 0;
    };

    protected constructor(id: number, label: string) {
        this.id = id;
        this.label = label;
    }

    public static CANCELED = new InterviewStatusEnum(10, "Canceled");
    public static SCHEDULED = new InterviewStatusEnum(20, "Scheduled");
    public static COMPLETED = new InterviewStatusEnum(30, "Completed");

    public static asArray = () => {
        return [InterviewStatusEnum.SCHEDULED, InterviewStatusEnum.COMPLETED, InterviewStatusEnum.CANCELED];
    };

    public static fromId = (id: number) => {
        return InterviewStatusEnum.asArray().find(t => t.id === id);
    };
}
